import { ApiClient } from 'app/service/api-service'
import { IPayloadCreateRewardActivity, IPayloadUpdateRewardActivity } from './model'
import { RewardActivityPoint } from './constant'
export const requestPostCreateRewardActivity = (
  body: IPayloadCreateRewardActivity,
) =>
  ApiClient.Post({
    url: RewardActivityPoint.CREATE,
    body,
  })

export const requestUpdateRewardActivity = (body: IPayloadUpdateRewardActivity) =>
  ApiClient.Put({
    url: RewardActivityPoint.UPDATE,
    body,
  })

export const requestDeleteRewardActivity = (id: number) =>
  ApiClient.Put({
    url: RewardActivityPoint.DELETE,
    body: { id },
  })
